import { Formik, Form } from 'formik';
import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSpotify } from 'react-icons/fa';
import { MdArrowBack } from 'react-icons/md';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { DefaultTheme, useTheme } from 'styled-components';
import { FiMail } from 'react-icons/fi';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import api from '../../../services/api';

const schema = yup.object({
  email: yup
    .string()
    .email('Digite um email válido')
    .required('Digite seu email'),
});

interface SubmitProps {
  email: string;
}

export const ForgotPassword = () => {
  const theme: DefaultTheme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async ({ email }: SubmitProps) => {
    try {
      setLoading(true);
      await api.post('/auth/forgot_password', { email });
      toast.success('Verifique seu email para recuperar sua senha');
    } catch (err: any) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
        return;
      }
      toast.error('Erro ao realizar login');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <Form>
        <h5 className="text-center">
          <FaSpotify
            size={65}
            color={theme.colors.secondary}
            className="mr-2"
          />
        </h5>
        <h4 className="text-center mt-3 mb-3">Recuperação de senha</h4>
        <h6>Informe seus e-mail para recuperar sua senha</h6>

        <Input type="email" name="email" placeholder="Email" icon={FiMail} />
        <Button
          className="mt-4"
          type="submit"
          background={theme.colors.secondary}
          loading={loading || undefined}
          color="#fff"
        >
          Recuperar
        </Button>
        <div className="d-flex justify-content-center">
          <Link to="/" className="mt-4 link-redirect">
            <MdArrowBack className="mr-1" />
            Voltar para o login
          </Link>
        </div>
      </Form>
    </Formik>
  );
};
